import { useState, useEffect } from "react"
import { collection, query, limit, getDocs } from "firebase/firestore"
import { auth } from "@/api/firebase"
import { db } from "@/api/firestore"

/**
 * Hook to check if the current user has any trips.
 * Returns null while loading, boolean once loaded.
 */
export function useHasTrips() {
  const [hasTrips, setHasTrips] = useState<boolean | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const checkTrips = async () => {
      const user = auth.currentUser
      if (!user) {
        setHasTrips(false)
        setLoading(false)
        return
      }

      try {
        const tripsRef = collection(db, "users", user.uid, "trips")
        const q = query(tripsRef, limit(1))
        const snapshot = await getDocs(q)
        setHasTrips(!snapshot.empty)
      } catch (err) {
        console.error("Failed to check trips:", err)
        setHasTrips(false)
      } finally {
        setLoading(false)
      }
    }

    checkTrips()
  }, [])

  return { hasTrips, loading }
}
